module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_03@2x-1289ac3dd90d5b02dcbc407c94438ee4.jpg";